export default function (cli) {
  return {
    getCategories () {
      return cli.get(`${cli.crmApiEndpoint}categories/`).query()
    },
    addCategory (data) {
      return cli.post(`${cli.crmApiEndpoint}categories/`).send(data)
    },
    editCategory (data) {
      return cli.patch(`${cli.crmApiEndpoint}categories/${data.pk}/`).send(data)
    },
    deleteCategory (pk) {
      return cli.del(`${cli.crmApiEndpoint}categories/${pk}/`).send()
    },
    updateListOrder (data) {
      return cli.post(`${cli.crmApiEndpoint}categories/update-list-order/`).send(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/categories.js